exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".template-input {\n  cursor: text;\n}\n.template-input ul {\n  list-style: none;\n}\n.template-input ul li {\n  display: inline-block;\n  vertical-align: middle;\n}\n", ""]);
